"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voice-chat.error.noModelOrAvatar': 'Por favor selecciona un modelo o avatar para iniciar la conversación por voz.',
};
